import {
  DATE_FORMAT_ISO_FNS,
  DATE_FORMAT_LONG_FNS,
  DATE_FORMAT_LONG_MINUTE_FNS,
} from '../../../CorePackage/MainModule/constants/dateFormats';
import { convertInitialKnmDateToFormDate } from './convertInitialKnmDateToFormDate';
import { IKnmErknmEventSubmittedDocumentsForm } from '../../../KnmErknmPackage/MainModule/interfaces/IKnmErknmEventSubmittedDocumentsForm';
import { IKnmErknmEventSubmittedDocuments } from '../../../KnmErknmPackage/MainModule/interfaces/IKnmErknmEventSubmittedDocuments';
import { handleReactQuillDeltaValue } from '../../../functions/handleReactQuillDeltaValue';

export const createSubmittedDocuments = (submittedDocuments: IKnmErknmEventSubmittedDocuments[] | undefined) => {
  if (!submittedDocuments) return undefined;

  return submittedDocuments.map(doc => {
    const document: IKnmErknmEventSubmittedDocumentsForm = {
      ...doc,
      isNew: false,
      requestDateTime: convertInitialKnmDateToFormDate(
        doc.requestDateTime,
        DATE_FORMAT_LONG_MINUTE_FNS,
        DATE_FORMAT_ISO_FNS,
      ),
      submissionDateTime: convertInitialKnmDateToFormDate(
        doc.submissionDateTime,
        DATE_FORMAT_LONG_MINUTE_FNS,
        DATE_FORMAT_ISO_FNS,
      ),
      submissionDeadline: convertInitialKnmDateToFormDate(doc.submissionDeadline, DATE_FORMAT_LONG_FNS),
      status: {
        code: doc.status?.code || '',
        id: doc.status?.id || 0,
        title: doc.status?.title || '',
        weight: doc.status?.weight || 0,
        label: doc.status?.title || '',
        value: doc.status?.code || '',
      },
      descriptionReactQuillEditor: handleReactQuillDeltaValue(
        doc.descriptionReactQuillEditor || doc.description || null,
      ),
    };

    return document;
  });
};
